import {settingConstants} from "../constants/setting.constants";

const initState = {
    configList: null,
    validationError: null
};

export function settingReducer(state = initState, action) {
    switch (action.type) {
        case settingConstants.CONFIG_REQUEST:
        case settingConstants.CONFIG_FAILURE:
            return {
                ...state,
                configList: null,
            };
        case settingConstants.CONFIG_SUCCESS:
            return  {
                ...state,
                configList: action.configModel,
            };
        case settingConstants.VALIDATION_ERROR:
            return  {
                ...state,
                validationError: action.error
            }
        default: {
            return state
        }
    }
};
